import { selectFromUserDto } from '../../models';

export default selectFromUserDto()
  .id
  .organizationId
  .email
  .fullname
  .uuid
  .tempPassword
  .verified
  .projectsCount
  .defaultWorkspaceId
  .supportSessionUuid
  .metadata(m => m.uuid)
  .organization(o => o.name.uuid.experiments.settings(os => os.distanceUnit))
  .activeSupportSession(ass => ass.expiresOn.organization(so => so.name.uuid.experiments))
  .roles(b => b.name)
  .permissions(p => p.id.action)
  .companies(c => c.inviteStatus.inviteLink.invitingUser(u => u.fullname.organization(o => o.name)))
  .toString();
